import React, {Component} from 'react';
import classNames from 'classnames';
import {Route, withRouter, Redirect, Switch, matchPath} from 'react-router-dom';
import { connect } from 'react-redux';
import GlobalStyle from './global-styles';
import AppTopbar from './AppTopbar';
import {AppFooter} from './AppFooter';
import {AppMenu} from './AppMenu';
import {AppProfile} from './AppProfile';
import {FormsDemo} from './components/FormsDemo';
import {SampleDemo} from './components/SampleDemo';
import {DataDemo} from './components/DataDemo';
import {PanelsDemo} from './components/PanelsDemo';
import {OverlaysDemo} from './components/OverlaysDemo';
import {MenusDemo} from './components/MenusDemo';
import {MessagesDemo} from './components/MessagesDemo';
import {ChartsDemo} from './components/ChartsDemo';
import {MiscDemo} from './components/MiscDemo';
import {EmptyPage} from './components/EmptyPage';
import Dashboard from './Containers/Dashboard/Dashboard';


// import Headcount from './Containers/Headcount/Headcount';
// import Empcalendar from './Containers/Empcalendar/Empcalendar';
// import DashboardService from './Containers/DashboardService/DashboardService';
import LeaveRequest from './Containers/EmployeeServices/LeaveRequest/LeaveRequest';
// import Clearance from './Containers/EmployeeServices/Clearance/Clearance';
// import ShiftApproval from './Containers/EmployeeServices/ShiftApproval/ShiftApproval';
// import Payslip from './Containers/EmployeeServices/Payslip/Payslip';
// import ECPrinting from './Containers/EmployeeServices/ECPrinting/ECPrinting';
// import TravelAuth from './Containers/EmployeeServices/TravelAuth/TravelAuth';

import ProcessList from './Containers/Masters/ProcessList/ProcessList';
import ProcessForm from './Containers/Masters/ProcessForm/ProcessForm';
import {Search} from './Containers/Search/Search';

import UserManagement from './Containers/Masters/UserManagement/UserManagement';
import AddUser from './Containers/Masters/UserManagement/AddUser';
// import { EmployeeAction } from './Containers/EmployeeAction/EmployeeAction';

import 'primereact/resources/themes/mdc-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import './layout/layout.scss';
import './layout/fonts.scss';
import './App.scss';
// import { YearlyEvaluation } from './components/YearlyEvaluation/YearlyEvaluation';
// import { YearlyTravelPlan } from './Containers/YearlyTravelPlan/YearlyTravelPlan';
import Logout from './Containers/Auth/Logout';
import { Policy } from './Containers/Policy/Policy';
import { Settings } from './Containers/Settings/Settings';
import TimeOffType from './Containers/TimeOffType/TimeOffType';
// import { BusinessSupport } from './Containers/BusinessSupport/BusinessSupport';

import * as actions from './store/actions/index';
import { GET_SESSION_HOME_PATH, GUEST_HOME_PATH, IS_GUEST_SESSION, LOGIN_PATH } from './shared/utility';
import Login from './Containers/Auth/Login';
import EmployeeGroup from './Containers/Masters/EmployeeGroup/EmployeeGroup';
import AddEmployeeGroup from './Containers/Masters/EmployeeGroup/AddEmployeeGroup';
import EmployeeMaster from './Containers/Masters/EmployeeMaster/EmployeeMaster';
import AddEmployeeMaster from './Containers/Masters/EmployeeMaster/AddEmployeeMaster';
import WPStatusMaster from './Containers/Masters/WPStatusMaster/WPStatusMaster';
import AddWPStatusMaster from './Containers/Masters/WPStatusMaster/AddWPStatusMaster';
import AddCertificateMaster from './Containers/Masters/CertificateMaster/AddCertificateMaster';
import CertificateMaster from './Containers/Masters/CertificateMaster/CertificateMaster';
import DailyShift from './Containers/Masters/DailyShift/DailyShift';
import AddDailyShift from './Containers/Masters/DailyShift/AddDailyShift';
import PeriodicWorkSchedule from './Containers/Masters/PeriodicWorkSchedule/PeriodicWorkSchedule';
import AddPeriodicSchedule from './Containers/Masters/PeriodicWorkSchedule/AddPeriodicWorkSchedule';
import PunchEditing from './Containers/Masters/PunchEditing/PunchEditing';
import AddPunchEditing from './Containers/Masters/PunchEditing/Punch';
import ApprovalType from './Containers/Approval/ApprovalType/ApprovalType';
import ApprovalPath from './Containers/Approval/ApprovalPath/ApprovalPath';
import LeaveRequestList from './Containers/EmployeeServices/LeaveRequest/LeaveRequestList';
// import BreakPermissionProcess from './Containers/TimeManagement/BreakPermissionProcess';
// import BreakPermissionProcessRequest from './Containers/TimeManagement/BreakPermissionRequest';
import PayrollReport from './Containers/TimeManagement/PayrollReport';
import AddPayrollReport from './Containers/TimeManagement/AddPayrollReport';
import CompanyMaster from './Containers/Masters/Company/CompanyMaster';
import HolidayMaster from './Containers/Masters/Holiday/HolidayMaster';
import KeywordMaster from './Containers/Masters/Keyword/KeywordMaster';

// import Request from './Containers/EmployeeServices/Request/Request';


// import VacationRequest from './Containers/EmployeeServices/VacationRequest/VacationRequest';
// import VacationRequestList from './Containers/EmployeeServices/VacationRequest/VacationRequestList';
// import FlexibleTiming2 from './Containers/EmployeeServices/FlexibleTiming/FlexibleTiming2';
// import FlexibleTimingList from './Containers/EmployeeServices/FlexibleTiming/FlexibleTimingList';
// import CarryForwardAnnual from './Containers/EmployeeServices/CarryForwardAnnual/CarryForwardAnnual';
// import CarryForwardAnnualList from './Containers/EmployeeServices/CarryForwardAnnual/CarryForwardAnnualList';
// import ExtendLeaveRequest from './Containers/EmployeeServices/ExtendLeaveRequest/ExtendLeaveRequest';
// import ExtendLeaveRequestList from './Containers/EmployeeServices/ExtendLeaveRequest/ExtendLeaveRequestList';

// import workSchedule from './Containers/EmployeeServices/ShiftApproval/workSchedule';
// import AdditionalLeaveQuotaList from './Containers/EmployeeServices/AdditionalLeaveQuota/AdditionalLeaveQuotaList';
// import AdditionalLeaveQuota from './Containers/EmployeeServices/AdditionalLeaveQuota/AdditionalLeaveQuota';
// import CallBackFromLeaveList from './Containers/EmployeeServices/CallBackFromLeave/CallBackFromLeaveList';
// import CallBackFromLeave from './Containers/EmployeeServices/CallBackFromLeave/CallBackFromLeave';
import News from './Containers/Masters/Company/News/News';
import CompanyPolicy from './Containers/Masters/Company/Policy/Policy';
import EmailTemplateMaster  from './Containers/Masters/EmailTemplateMaster/EmailTemplateMaster';
import EmailTemplateMasterlist from './Containers/Masters/EmailTemplateMaster/EmailTemplateMasterlist';

import { OrganizationCharts } from './Containers/OrganizationChart/OrganizationChart';
import PositionChart from './Containers/OrganizationChart/PositionChart';
import { DepartmentCharts } from './Containers/OrganizationChart/DepartmentChart';
import PositionMaster from './Containers/Masters/PositionMaster/PositionMaster';
import AddPosition from './Containers/Masters/PositionMaster/AddPosition';
import OrganizationUnit from './Containers/Masters/OrganizationUnit/OrganizationUnit';
import AddOrganizationUnit from './Containers/Masters/OrganizationUnit/AddOrganizationUnit';
import HelpLibrary from './Containers/Masters/HelpLibrary/HelpLibrary';
import Role from './Containers/Masters/Role/Role';
import {Menu} from 'primereact/menu';
import TimeOffTypeList from './Containers/TimeOffType/TimeOffTypeList';
import Messages from './shared/UI/Messages/Messages';
// import ExpensesClaim from './Containers/EmployeeServices/ExpensesClaim/ExpensesClaim';
import ReportsSetting from './Containers/Reports/ReportsSetting';
import ReportsList from './Containers/Reports/ReportsList';
// import JobRequisitions from './Containers/Recruitment/JobRequisitions/JobRequisitions';
// import AddJobApplication from './Containers/Recruitment/JobApplication.js/AddJobApplication';
// import JobApplicationList from './Containers/Recruitment/JobApplication.js/JobApplicationList';
// import AddJobRequisitions from './Containers/Recruitment/JobRequisitions/AddJobRequisitions';
// import ViewJobRequisitions from './Containers/Recruitment/JobRequisitions/ViewJobRequisitions';
// import Candidates from './Containers/Recruitment/Candidates/Candidates';
// import AddCandidates from './Containers/Recruitment/Candidates/AddCandidates';
// import ApproveJobRequisitions from './Containers/Recruitment/JobRequisitions/ApproveJobRequisitions';
// import Configuration from './Containers/Recruitment/JobRequisitions/Configuration';
// import ViewApplicationForm from './Containers/Recruitment/JobRequisitions/ViewApplicationForm';

import TimeOffTypePolicyList from './Containers/TimeOffType/TimeOffTypePolicy/TimeOffTypePolicyList';
import TimeOffTypePolicy from './Containers/TimeOffType/TimeOffTypePolicy/TimeOffTypePolicy';
// import OverTimePreApprovalList from './Containers/EmployeeServices/OverTimePreApproval/OverTimePreApprovalList';
// import OverTimePreApproval from './Containers/EmployeeServices/OverTimePreApproval/OverTimePreApproval';
// import DelegationOfAuthority from './Containers/DelegationOfAuthority/DelegationOfAuthority';
import ErrorLogs from './Containers/ErrorLogs/ErrorLogs';
import TimeSheet from './Containers/TimeManagement/TimeSheet';
import AddTimesheetProcess from './Containers/TimeManagement/AddTimesheetProcess';
import ViewTimeSheet from './Containers/TimeManagement/ViewTimeSheet';
// import LeaveCancellation from './Containers/EmployeeServices/LeaveCancellation/LeaveCancellationRequest';
// import LeaveCancellationList from './Containers/EmployeeServices/LeaveCancellation/LeaveCancellationList';
import SapIdoc from './Containers/SAP/SapIdoc';


// import JoiningProcessList from './Containers/Recruitment/Joining/JoiningProcessList';
// import AddJoiningProcess from './Containers/Recruitment/Joining/AddJoiningProcess';
// import RankingProcessList from './Containers/Recruitment/Ranking/RankingProcessList';
// import AddRankingProcess from './Containers/Recruitment/Ranking/AddRankingProcess';
// import InterviewProcessList from './Containers/Recruitment/Interview/InterviewProcessList';
// import AddInterview from './Containers/Recruitment/Interview/AddInterview';
// import ShortListing from './Containers/Recruitment/ShortListing/ShortListing';
// import AddShortListing from './Containers/Recruitment/ShortListing/AddShortListing';
// import AssessmentForm from './Containers/Recruitment/Interview/AssessmentForm';
// import AddBusinessTrip from './Containers/EmployeeServices/BusinessTrip/AddBusinessTrip';
// import BusinessTrip from './Containers/EmployeeServices/BusinessTrip/BusinessTrip';
// import AddTravelAuthorization from './Containers/EmployeeServices/TravelAuthorization/AddTravelAuthorization';
// import TravelAuthorization from './Containers/EmployeeServices/TravelAuthorization/TravelAuthorization';
// import AddMaterialPassIn from './Containers/Security/MaterialPassIn/AddMaterialPassIn';
// import MaterialPassInList from './Containers/Security/MaterialPassIn/MaterialPassInList';
// import GatePassVisitorList from './Containers/Security/GatePassVisitor/GatePassVisitorList'
// import AddGatePassVisitor from './Containers/Security/GatePassVisitor/AddGatePassVisitor'
// import MaterialPassOutList from './Containers/Security/MaterialPassOut/MaterialPassOutList'
// import AddMaterialPassOut from './Containers/Security/MaterialPassOut/AddMaterialPassOut'
// import MaterialPassVehicleList from './Containers/Security/MaterialPassVehicle/MaterialPassVehicleList'
// import AddMaterialPassVehicle from './Containers/Security/MaterialPassVehicle/AddMaterialPassVehicle'
// import WorkPermitList from './Containers/Operation/WorkPermit/WorkPermitList'
// import AddWorkPermit from './Containers/Operation/WorkPermit/AddWorkPermit'
// import WorkPermitError from './shared/WorkPermitError';
// import AddProcessIncidentReport from './Containers/Operation/ProcessIncidentReport/AddProcessIncidentReport'
// import ProcessIncidentReportList from './Containers/Operation/ProcessIncidentReport/ProcessIncidentReportList'
// import Simulation from './Containers/Operation/Simulation/SimulationList'
// import AddSimulation from './Containers/Operation/Simulation/AddSimulation'
// import Moc from './Containers/Operation/PlantModificationManagement/MocList'
// import AddMoc from './Containers/Operation/PlantModificationManagement/AddMoc'
// import AddTmoc from './Containers/Operation/TemporaryPlantModification/AddTmoc'
// import TmocList from './Containers/Operation/TemporaryPlantModification/TmocList'
import KpiList from './Containers/Masters/KpiMaster/KpiList'
import AddKpi from './Containers/Masters/KpiMaster/AddKpi'
import SlaList from './Containers/Masters/SLA/SLA'
import AddSla from './Containers/Masters/SLA/AddSla'
// import AnalyticsHr from './Containers/Analytics/AnalayticsHR'
// import AddService from './Containers/ServiceDesk/ServiceDesk/AddService'
// import ServiceList from './Containers/ServiceDesk/ServiceDesk/ServiceList';

// import AddITSMIncident from './Containers/ServiceDesk/IncidentManagement/AddITSMIncident'
// import ITSMIncidentList from './Containers/ServiceDesk/IncidentManagement/ITSMIncidentList';
// import AddITSMProblem from './Containers/ServiceDesk/ProblemManagement/AddITSMProblem'
// import ITSMProblemList from './Containers/ServiceDesk/ProblemManagement/ITSMProblemList';
// import AddITSMChange from './Containers/ServiceDesk/ChangeManagement/AddITSMChange'
// import ITSMChangeList from './Containers/ServiceDesk/ChangeManagement/ITSMChangeList';

import AddRecInvoice from './Containers/Finance/ServiceDesk/AddInvoice'
import InvoiceList from './Containers/Finance/ServiceDesk/InvoiceList';

// import AddKPIActual from './Containers/KPI/KPIActual/AddKPIActual'
// import KPIActualList from './Containers/KPI/KPIActual/KPIActualList';

// import AddKPITarget from './Containers/KPI/KPITarget/AddKPITarget'
// import KPITargetList from './Containers/KPI/KPITarget/KPITargetList';

import AnalyticsOM from './Containers/Analytics/AnalayticsOperation'
import AnalayticsOperation from './Containers/Analytics/AnalayticsOperation';
import AnalyticsHr from  './Containers/Analytics/AnalayticsHR';

// import AddAdvanceRequest from './Containers/EmployeeServices/AdvanceRequest/AddAdvanceRequest';
// import AdvanceList from './Containers/EmployeeServices/AdvanceRequest/AdvanceList';

//import EmployeeMonthlyEvaluation from './Containers/EmployeeEvaluation/EmployeeMonthlyEvaluation'



import MaterialPassVehicleList from './Containers/Security/MaterialPassVehicle/MaterialPassVehicleList';
import AddMaterialPassVehicle from './Containers/Security/MaterialPassVehicle/AddMaterialPassVehicle';

import ProjectList from './Containers/Masters/Project/ProjectList';
import AddProject from './Containers/Masters/Project/Project';



import VendorList from './Containers/Masters/Vendor/VendorList';
import AddVendor from './Containers/Masters/Vendor/Vendor';


import GatePassVisitorList from './Containers/Security/GatePassVisitor/GatePassVisitorList'
import AddGatePassVisitor from './Containers/Security/GatePassVisitor/AddGatePassVisitor'


import BusinessTrip from './Containers/EmployeeServices/BusinessTrip/BusinessTrip';
import AddBusinessTrip from './Containers/EmployeeServices/BusinessTrip/AddBusinessTrip';


import OverTimePreApprovalList from './Containers/EmployeeServices/OverTimePreApproval/OverTimePreApprovalList';
import OverTimePreApproval from './Containers/EmployeeServices/OverTimePreApproval/OverTimePreApproval';


import MoblizationList from './Containers/EmployeeServices/Moblization/MoblizationList';
import Moblization from './Containers/EmployeeServices/Moblization/Moblization';

import DeMoblizationList from './Containers/EmployeeServices/DeMoblization/DeMoblizationList';
import DeMoblization from './Containers/EmployeeServices/DeMoblization/DeMoblization';


import BreakPermissionProcess from './Containers/TimeManagement/BreakPermissionProcess';
import BreakPermissionProcessRequest from './Containers/TimeManagement/BreakPermissionRequest';

//CostCenterMaster
import CostCenter from './Containers/Masters/CostCenter/CostCenter';
import AddCostCenter from './Containers/Masters/CostCenter/AddCostCenter';  

//Event Management
import EventManagement from './Containers/EventManagement/EventManagement';
import AddEventManagement from './Containers/EventManagement/AddEventManagement';

import NumberingScheme from './Containers/Masters/NumberingScheme/NumberingScheme';
import NumberingSchemeList from './Containers/Masters/NumberingScheme/NumberingSchemeList';

import Peoplelist from './Containers/Masters/People/Peoplelist';
import AddPeople from './Containers/Masters/People/AddPeople';


import ShiftApproval from './Containers/EmployeeServices/ShiftApproval/ShiftApproval';
import ShiftApprovalSingle from './Containers/EmployeeServices/ShiftApprovalSingle/ShiftApprovalSingle';

import workSchedule from './Containers/EmployeeServices/ShiftApproval/workSchedule';
import workScheduleSingle from './Containers/EmployeeServices/ShiftApprovalSingle/workScheduleSingle';

import TimeBookingList from './Containers/EmployeeServices/TimeBooking/TimeBookingList';
import AddTimeBooking from './Containers/EmployeeServices/TimeBooking/TimeBooking';

import DailyActivity from './Containers/EmployeeServices/DailyActivity/DailyActivity';
import AddDailyActivity from './Containers/EmployeeServices/DailyActivity/AddDailyActivity';


import EmployeeLoan from './Containers/EmployeeServices/EmployeeLoan/EmployeeLoan';
import AddEmployeeLoan from './Containers/EmployeeServices/EmployeeLoan/AddEmployeeLoan';

import InventoryDashboard from './Containers/InventoryDashboard/InventoryDashboard';

import Recipe from './Containers/Masters/Recipe/Recipe';
import AddRecipe from './Containers/Masters/Recipe/AddRecipe';

import Assembly from './Containers/Masters/Assembly/Assembly';
import AddAssembly from './Containers/Masters/Assembly/AddAssembly';

import PurchaseOrder from './Containers/InventoryServices/PurchaseOrder/PurchaseOrder';
import AddPurchaseOrder from './Containers/InventoryServices/PurchaseOrder/AddPurchaseOrder';
import Wastage from './Containers/InventoryServices/Wastage/Wastage';
import AddWastage from './Containers/InventoryServices/Wastage/AddWastage';
import GoodsReceiptNote from './Containers/InventoryServices/GoodsReceiptNote/GoodsReceiptNote';
import AddGoodsReceiptNote from './Containers/InventoryServices/GoodsReceiptNote/AddGoodsReceiptNote';

import FinancialStatementVersion from './Containers/Masters/FinancialStatementVersion/FinancialStatementVersion';
import AddFinancialStatementVersion from './Containers/Masters/FinancialStatementVersion/AddFinancialStatementVersion';

import ModuleSelectionPage from './Containers/ModuleSelectionPage/ModuleSelectionPage';
import InventorySettings from './Containers/InventorySettings/InventorySettings';
import BarcodeGeneration from './Containers/InventoryServices/BarcodeGeneration/BarcodeGeneration';
import CurrentstockReport from './Containers/InventoryServices/CurrentstockReport/CurrentstockReport';
import FoodCostingReport from './Containers/InventoryServices/FoodCostingReport/FoodCostingReport';
import ExpiryReport from './Containers/InventoryServices/ExpiryReport/ExpiryReport';
import StockSummaryReport from './Containers/InventoryServices/StockSummaryReport/StockSummaryReport';

import AssetMaster from './Containers/Masters/AssetMaster/AssetMaster';
import AddAssetMaster from './Containers/Masters/AssetMaster/AddAssetMaster';


import AccountsMaster from './Containers/Masters/AccountsMaster/AccountsMaster';
import AddAccountsMaster from './Containers/Masters/AccountsMaster/AddAccountsMaster';

import Ingredient from './Containers/Masters/Ingredient/Ingredient';
import AddIngredient from './Containers/Masters/Ingredient/AddIngredient';

import Menuitem from './Containers/Masters/Menuitem/Menuitem';
import AddMenuitem from './Containers/Masters/Menuitem/AddMenuitem';
import Menuitemcat from './Containers/Masters/Menuitemcat/Menuitemcat';
import AddMenuitemcat from './Containers/Masters/Menuitemcat/AddMenuitemcat';

import PurchaseReturn from './Containers/InventoryServices/PurchaseReturn/PurchaseReturn';
import AddPurchaseReturn from './Containers/InventoryServices/PurchaseReturn/AddPurchaseReturn';

import MRP from './Containers/InventoryServices/MaterialRequirementPlanning/MRP';
import GenerateProductionPlanning from './Containers/InventoryServices/GenerateProductionPlanning/GenerateProductionPlanning';

import Modifier from './Containers/Masters/Modifier/Modifier';
import AddModifier from './Containers/Masters/Modifier/AddModifier';

import ModifierGroup from './Containers/Masters/ModifierGroup/ModifierGroup';
import AddModifierGroup from './Containers/Masters/ModifierGroup/AddModifierGroup';

import POSApp from './POS/POSApp';

import OutletMaster from './Containers/Masters/Outlet/OutletMaster';
import AddOutletMaster from './Containers/Masters/Outlet/AddOutletMaster';

import StoreMaster from './Containers/Masters/StoreMaster/StoreMaster';
import AddStoreMaster from './Containers/Masters/StoreMaster/AddStoreMaster';

import KitchenMaster from './Containers/Masters/KitchenMaster/KitchenMaster';
import AddKitchenMaster from './Containers/Masters/KitchenMaster/AddKitchenMaster';

import ZatcaCompany from './Containers/Masters/Zatca/ZatcaCompany';
import ZatcaUnits from './Containers/Masters/Zatca/ZatcaUnits';
import AddZatcaUnit from './Containers/Masters/Zatca/AddZatcaUnit';
import ZatcaOnboarding from './Containers/Masters/Zatca/ZatcaOnboarding';
import ZatcaMonitor from './Containers/Masters/Zatca/ZatcaMonitor';
import Headcount from './Containers/Headcountandcalendar/HeadCount/Headcount';
import Empcalendar from './Containers/Headcountandcalendar/Calendar/Empcalendar';

// Property related 
import TenantsAndOwners from './Containers/Masters/TenantsAndOwners/TenantsAndOwners';
import AddTenantsAndOwners from './Containers/Masters/TenantsAndOwners/AddTenantsAndOwners';
import Service from './Containers/Masters/TenantsAndOwners/Service';
import AddService from './Containers/Masters/TenantsAndOwners/AddService';
import TenantZone from './Containers/Masters/TenantsAndOwners/TenantZone';
import AddTenantZone from './Containers/Masters/TenantsAndOwners/AddTenantZone';
import PropertyGroup from './Containers/Masters/TenantsAndOwners/PropertyGroup';
import AddPropertyGroup from './Containers/Masters/TenantsAndOwners/AddPropertyGroup';
import Property from './Containers/Masters/TenantsAndOwners/Property';
import AddProperty from './Containers/Masters/TenantsAndOwners/AddProperty';
import MovieIn from './Containers/Masters/TenantsAndOwners/MovieIn';
import AddMovieIn from './Containers/Masters/TenantsAndOwners/AddMovieIn';
import GuestsAndEmployeeUploads from './Containers/Masters/GuestsAndEmployeeUploads/GuestsAndEmployeeUploads';
import OrderInfo from './Containers/Masters/OrderInfo/OrderInfo';
import RateCard from './Containers/Masters/RateCard/RateCard';
import TaxMaster from './Containers/Masters/TaxMaster/TaxMaster';
import AddTaxMaster from './Containers/Masters/TaxMaster/AddTaxMaster';
import Soldout from './Containers/Masters/Soldout/Soldout';
import JournalVoucher from './Containers/InventoryServices/JournalVoucher/JournalVoucher';
import JournalVoucherList from './Containers/InventoryServices/JournalVoucher/JournalVoucherList';
import SalesOrder from './Containers/InventoryServices/SalesOrder/SalesOrder';
import SalesOrderList from './Containers/InventoryServices/SalesOrder/SalesOrderList';

import ConsumptionReport from './Containers/InventoryServices/ConsumptionReport/ConsumptionReport';
import DailySalesReport from './Containers/InventoryServices/SalesReport/DailySalesReport';
import RestaurantDailySalesReport from './Containers/FormattedReport/RestaurantDailySalesReport/RestaurantDailySalesReport';
import ItemwiseSalesSummaryReport from './Containers/FormattedReport/ItemwiseSalesSummaryReport/ItemwiseSalesSummaryReport';
import CashHandoverFromSalesReport from './Containers/FormattedReport/CashHandoverFromSalesReport/CashHandoverFromSalesReport';
import CashSummaryReport from './Containers/FormattedReport/CashSummaryReport/CashSummaryReport';
import EmployeeSalaryReport from './Containers/FormattedReport/EmployeeSalaryReport/EmployeeSalaryReport';
import SalesReport from './Containers/FormattedReport/SalesReport/SalesReport';

import MealPeriodList from './Containers/Masters/MealPeriodList/MealPeriodList';
import AddMealPeriodList from './Containers/Masters/MealPeriodList/AddMealPeriod';
import OccasionMaster from './Containers/Masters/OccasionMaster/OccasionMaster';
import AddOccasionMaster from './Containers/Masters/OccasionMaster/AddOccasionMaster';
import MenuItemMealPeriod from './Containers/Masters/MenuItemMealPeriod/MenuItemMealPeriod';
import AddMenuItemMealPeriod from './Containers/Masters/MenuItemMealPeriod/AddMenuItemMealPeriod';
import KOTInformationMaster from './Containers/Masters/KOTInformationMaster/KOTInformationMaster';
import AddKOTInformationMaster from './Containers/Masters/KOTInformationMaster/AddKOTInformationMaster';

import MasterSelection from './Containers/Masters/MasterSelection/MasterSelection';
import FormattedReportSelection from './Containers/FormattedReport/FormattedReportSelection/FormattedReportSelection';

import TableMaster from './Containers/Masters/TableMaster/TableMaster';
import AddTableMaster from './Containers/Masters/TableMaster/AddTableMaster';

import OrderType from './Containers/Masters/OrderType/OrderType';
import AddOrderType from './Containers/Masters/OrderType/AddOrderType';

import RequestforQuotation from './Containers/InventoryServices/RequestforQuotation/RequestforQuotation';
import AddRequestforQuotation from './Containers/InventoryServices/RequestforQuotation/AddRequestforQuotation';

import SupplierQuotation from './Containers/InventoryServices/SupplierQuotation/SupplierQuotationList';
import AddSupplierQuotation from './Containers/InventoryServices/SupplierQuotation/SupplierQuotation';

import VendorRegistrationList from './Containers/EmployeeServices/VendorRegistration/VendorRegistrationList';
import VendorRegistration from './Containers/EmployeeServices/VendorRegistration/VendorRegistration';

import OpeningStockList from './Containers/InventoryServices/OpeningStock/OpeningStockList';
import OpeningStock from './Containers/InventoryServices/OpeningStock/OpeningStock';

import PhysicalStockList from './Containers/InventoryServices/PhysicalStock/PhysicalStockList';
import PhysicalStock from './Containers/InventoryServices/PhysicalStock/PhysicalStock';

import ProductionPlanningList from './Containers/InventoryServices/ProductionPlanning/ProductionPlanning';
import AddProductionPlanning from './Containers/InventoryServices/ProductionPlanning/AddProductionPlanning';

import MaterialRequirementPlanningList from './Containers/InventoryServices/MaterialRequirementPlanning/MaterialRequirementPlanningList';
import AddMaterialRequirementPlanning from './Containers/InventoryServices/MaterialRequirementPlanning/AddMaterialRequirementPlanning';

import ImprestSystem from './Containers/InventoryServices/ImprestSystem/ImprestSystem';
import AddImprestSystem from './Containers/InventoryServices/ImprestSystem/AddImprestSystem';

import TransactionType from './Containers/Masters/TransactionType/TransactionType';
import AddTransactionType from './Containers/Masters/TransactionType/AddTransactionType';

import MarketingCampaignList from './Containers/InventoryServices/MarketingCampaign/MarketingCampaignList';
import MarketingCampaign from './Containers/InventoryServices/MarketingCampaign/MarketingCampaign';

import PurchaseRequisitionList from './Containers/InventoryServices/PurchaseRequisition/PurchaseRequisitionList';
import PurchaseRequisition from './Containers/InventoryServices/PurchaseRequisition/PurchaseRequisition';


class App extends Component {

    constructor() {
        super();
        this.state = {
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            items: [
            {label: 'View Photo', command:() => this.setState({viewPhoto:true}) },
            // {label: 'Upload Photo', command:() => this.setState({uploadPhoto:true}) },
            // {label: 'Take Photo', command:() => this.setState({takePhoto:true}) }, uncomment for the upload and take photo features
            ],
            viewPhoto : false,
            uploadPhoto : false,
            takePhoto : false,
            loadOnce : true
        };

        this.onWrapperClick = this
            .onWrapperClick
            .bind(this);
        this.onToggleMenu = this
            .onToggleMenu
            .bind(this);
        this.onSidebarClick = this
            .onSidebarClick
            .bind(this);
        this.onMenuItemClick = this
            .onMenuItemClick
            .bind(this);
        this.createMenu();
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({overlayMenuActive: false, mobileMenuActive: false});
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        } else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    // Things to do before unloading/closing the tab
    doSomethingBeforeUnload = () => {
        //localStorage.clear();
    }

    // Setup the `beforeunload` event listener
    setupBeforeUnloadListener = () => {
        // window.addEventListener("beforeunload", (ev) => {
        //     ev.preventDefault();      
        //     return this.doSomethingBeforeUnload();
        // });
        // window.addEventListener("beforeunload", (ev) => 
        //     {  
        //         ev.preventDefault();
        //         return ev.returnValue = 'Are you sure you want to close?';
        //     });

    };

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({overlayMenuActive: false, mobileMenuActive: false})
        }
    }

    createMenu() {
        this.menu1a = [
            // {label: 'Dashboard', icon: 'pi pi-fw pi-home', command: () =>
            // {window.location = '/'}},
            // {
            //     label: 'Dashboard',
            //     icon: 'pi pi-fw pi-home',
            //     to: '/dashboard'
                // command: () => {
                //     window.location.hash = "/dashboard";
                // }
            //},
            
            { label: 'Cost Center', icon: 'pi pi-fw pi-list', to: '/CostCenter' },
            
            {label: '', icon: '', to:''},
            {     
                
                    label: 'Company Policy', icon: 'pi pi-fw pi-file', 
                items: [ 		
                    {label: 'HR Policy', icon: 'pi pi-fw pi-file',items: [
                        {label: 'Leave Policy', icon: 'pi pi-fw pi-file', to:'/policy/Leave Policy'},
                        {label: 'Business Trip Policy', icon: 'pi pi-fw pi-file', to:'/policy/Business Trip Policy'},
                        {label: 'Performance & Appraisal Policy', icon: 'pi pi-fw pi-file', to:'/policy/Annual Performance and Appraisal Policy'},
                        {label: 'Training Policy', icon: 'pi pi-fw pi-file', to:'/policy/Training Policy'}
                    ]},
                    {label: 'Procurement Policy', icon: 'pi pi-fw pi-file', to:'/policy/Procurement Policy'}, 		
                    {label: 'Safety & Security (EHSS) Policy', icon: 'pi pi-fw pi-file', to:'/policy/Safety & Security (EHSS) Policy'}, 
                ] 
            },

            {     
                
                label: 'Recruitment', icon: 'pi pi-fw pi-users', 
                items: [ 		
                    {label: 'Job Requisitions', icon: 'pi pi-fw', to:'/job-requistions'},
                    {label: 'Candidates', icon: 'pi pi-fw', to:'/candidates'},
                ] 
            },
      
            // {     
                
            //     label: 'Time off Type', icon: 'pi pi-fw pi-clock', 
            //     items: [ 		
            //         {label: 'Time off Type', icon: 'pi pi-fw pi-clock', to:'/time-off-type-list'},
            //         {label: 'Time off Type Policy', icon: 'pi pi-fw pi-clock', to:'/time-off-type-policy'},   
                    
            //     ] 
            // },
            // {label: 'Help Library', icon: 'fa fa-question-circle', to:'/help-library'},
            {     
                
                label: 'HR - Employee Service', icon: 'pi pi-fw pi-user', 
                items: [ 	
                    
                    {label: 'Work Schedule', icon: 'pi pi-fw pi-clock',items: [
                        {label: 'Work Schedule', icon: 'pi pi-fw pi-clock', to:'/work-schedule'},
                        {label: 'Add Work Schedule', icon: 'pi pi-fw pi-clock', to:'/shift-approval'},  
                    ]},

                    {label: 'Clearance', icon: 'pi pi-fw pi-envelope', to:'/clearance'},
                    {label: 'Leave Request', icon: 'pi pi-fw pi-envelope', to: '/leave-request-list'},
                    {label: 'Vacation Plan Request', icon: 'pi pi-fw pi-envelope', to: '/request/Vacation-Plan/38ad007e-33bd-43b0-9fc7-b22cd60c0caf'},
                    {label: 'Vacation Plan Request', icon: 'pi pi-fw pi-envelope', to: '/vacation-request-list'},
                    {label: 'Flexible Timing Request', icon: 'pi pi-fw pi-envelope', to: '/flexible-timing-list'},
                    {label: 'Carry Forward Annual Request', icon: 'pi pi-fw pi-envelope', to: '/carry-forward-list'},
                    {label: 'Extend Leave Request', icon: 'pi pi-fw pi-envelope', to: '/extend-leave-request-list'},
                    {label: 'Additional Leave Quota Request', icon: 'pi pi-fw pi-envelope', to: '/additional-leave-quota-list'},
                    {label: 'Call Back From Leave Request', icon: 'pi pi-fw pi-envelope', to: '/call-back-leave-list'},
                    {label: 'Travel Authorization', icon: 'pi pi-fw pi-envelope', to: '/travel-authorization'} ,
                    {label: 'Expense Claim', icon: 'pi pi-fw pi-money-bill', to: '/expense-claim'},
                    // {label: 'Overtime Pre Approval', icon: 'pi pi-fw pi-money-bill', to: '/overtime-pre-approval'}
                    {label: 'Employee Loan', icon: 'pi pi-fw pi-money-bill', to: '/EmployeeLoan'},
                    
                    
                ] 
            },
           
            {     
                
                label: 'Masters', icon: 'pi pi-fw pi-users', 
                items: [ 		
                    // {label: 'Process List', icon: 'pi pi-fw pi-envelope', to:'/process-list'},
                    // {label: 'Company Master', icon: 'pi pi-fw pi-envelope',items: [
                    //     {label: 'Company Settings', icon: 'pi pi-fw pi-clock', to:'/company-master'},
                    //     {label: 'News Settings', icon: 'pi pi-fw pi-clock', to:'/news-settings'},
                    //     {label: 'Company Policy', icon: 'pi pi-fw pi-clock', to:'/company-policy'},  
                    // ]},
                    // {label: 'Organization Unit Master', icon: 'fa fa-envelope-square', to:'/organization-unit'},
                    // {label: 'Position Master', icon: 'fa fa-envelope-square', to:'/position-master'}, 
                    {label: 'Email Template Master', icon: 'fa fa-envelope-square', to:'/email-template-master'}, 
                    // {label: 'Holiday Master', icon: 'pi pi-fw pi-envelope', to:'/holiday-master'},
                    // {label: 'Keyword Master', icon: 'fa fa-key', to:'/keyword-master'},	
                    // {label: 'User Management', icon: 'pi pi-fw pi-user',items: [
                    //     {label: 'User', icon: 'pi pi-fw pi-user', to:'/users'},
                    //     {label: 'Role', icon: 'pi pi-fw pi-user', to:'/role-master'},
                    // ]},

                    // {label: 'Employee Group', icon: 'pi pi-fw pi-users', to:'/employee-group'}, 
                    // {label: 'Employee Master', icon: 'pi pi-fw pi-users', to:'/employee-master'}, 
                    // {label: 'Daily Shift', icon: 'pi pi-fw pi-clock', to:'/daily-shift'},
                    // {label: 'Shift Pattern', icon: 'pi pi-fw pi-clock', to:'/periodic-schedule'}, 
                    {label: 'Punch Editing', icon: 'pi pi-fw pi-clock', to:'/punch-editing'}, 
                    
                ] 
            },
            {     
                
                label: 'Organization Chart', icon: 'fa fa-sitemap', 
                items: [ 		
                    // {label: 'Organization Chart', icon: 'fa fa-sitemap', to:'/organization-chart'},
                    // {label: 'Position Chart', icon: 'fa fa-sitemap', to:'/position-chart'},
                    {label: 'Department Chart', icon: 'fa fa-sitemap', to:'/department-chart'},
                ] 
            },
            // {     
                
            //     label: 'Approval', icon: 'pi pi-fw pi-chart-bar', 
            //     items: [ 		
            //         {label: 'Approval Type', icon: 'pi pi-fw pi-envelope', to:'/approval-type'},
            //         {label: 'Approval Path', icon: 'pi pi-fw pi-user', to:'/approval-path'}
            //     ] 
            // },
            {     
                
                label: 'Time & Attendance Management', icon: 'pi pi-fw pi-clock', 
                items: [ 		
                    
                    {label: 'TimeSheet', icon: 'pi pi-fw pi-clock', to:'/timesheet'},
                    {label: 'Break Permission', icon: 'pi pi-fw pi-clock', to:'/break-permission-process'},
                    {label: 'Payroll Report', icon: 'pi pi-fw pi-money-bill', to:'/payroll-report'},
                ] 
            },
            {     
                
                label: 'HR - Planning', icon: 'pi pi-fw pi-chart-bar', 
                items: [ 		
                    {label: 'Employee Action', icon: 'pi pi-fw pi-envelope', to:'/employee-action'},
                    {label: 'Yearly Evaluation', icon: 'pi pi-fw pi-user', to:'/yearly-evaluation'}, 		
                    {label: 'Yearly Travel Plan', icon: 'pi pi-fw pi-user', to:'/travel-plan'}, 
                ] 
            },
            
            {     
                
                label: 'HR - Business Support', icon: 'pi pi-fw pi-user', 
                items: [ 		
                    {label: 'GR - Government Relations', icon: 'pi pi-fw pi-envelope', to:'/business-support/GR - Government Relations'},    
                    {label: 'Recruitment', icon: 'pi pi-fw pi-clock', to:'/business-support/Recruitment'},    
                ] 
            },
            {     
                
                label: 'HR - Training & Development', icon: 'pi pi-fw pi-user', 
                items: [ 		
                    {label: 'New Employee Training', icon: 'pi pi-fw pi-envelope', to:'/business-support/New Employee Training'},    
                    {label: 'Succession Plan', icon: 'pi pi-fw pi-clock', to:'/business-support/Succession Plan'},    
                ] 
            },
            {     
                
                label: 'HR - Admin & General Services', icon: 'pi pi-fw pi-user', 
                items: [ 		
                    {label: 'Courier Service Request', icon: 'pi pi-fw pi-envelope', to:'/business-support/Courier Service Request'},    
                    {label: 'Telecommunication Request', icon: 'pi pi-fw pi-clock', to:'/business-support/Telecommunication Request'},
                    {label: 'Transportation Request', icon: 'pi pi-fw pi-envelope', to:'/business-support/Transportation Request'},    
                    {label: 'Vehicle Cross Border Permit Request', icon: 'pi pi-fw pi-clock', to:'/business-support/Vehicle Cross Border Permit Request'}, 
                ] 
            },
            // {     
                
            //     label: 'Reporting System', icon: 'pi pi-fw  pi-chart-bar', 
            //     items: [ 		
            //         {label: 'Reports and Setting', icon: 'pi pi-fw pi-envelope', to:'/reports-setting'},    
            //     ] 
            // },
            {
                label: 'Error Logs',
                icon: 'pi pi-fw pi-search',
                to: '/error-logs'
            },
            // {
            //     label: 'Delegation Of Authority',
            //     icon: 'pi pi-fw pi-search',
            //     to: '/delegation-of-authority'
            // },
            {
                label: 'Request Search',
                icon: 'pi pi-fw pi-search',
                to: '/search'
            },
            // {     label: 'Components', icon: 'pi pi-fw pi-globe', badge: '9',
            // items: [ 		{label: 'Sample Page', icon: 'pi pi-fw pi-th-large', to:
            // '/sample'}, 		{label: 'Forms', icon: 'pi pi-fw pi-file', to: '/forms'},
            //         {label: 'Data', icon: 'pi pi-fw pi-table', to: '/data'}, 		{label:
            // 'Panels', icon: 'pi pi-fw pi-list', to: '/panels'}, 		{label: 'Overlays',
            // icon: 'pi pi-fw pi-clone', to: '/overlays'}, 		
            // {label: 'Menus', icon: 'pipi-fw pi-plus', to: '/menus'}, 		
            // {label: 'Messages', icon: 'pi pi-fw  pi-spinner',to: '/messages'}, 
            //         {label: 'Charts', icon: 'pi pi-fw pi-chart-bar', to: '/charts'}, 		{label: 'Misc', icon: 'pi pi-fw pi-upload',
            // to: '/misc'}     ] }, {     label: 'Template Pages', icon: 'pi pi-faccfw pi-file',    
            // items: [         {label: 'Empty Page', icon: 'pi pi-fw pi-circle-off', to: '/empty'}     ] },

        ];
    }

    addClass(element, className) {
        if (element.classList) 
            element.classList.add(className);
        else 
            element.className += ' ' + className;
        }
    
    removeClass(element, className) {
        if (element.classList) 
            element.classList.remove(className);
        else 
            element.className = element
                .className
                .replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
    
    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        const Lang = localStorage.getItem('Lang');
        if (this.state.mobileMenuActive) 
            this.addClass(document.body, 'body-overflow-hidden');
        else 
            this.removeClass(document.body, 'body-overflow-hidden');

        if(this.props.menuLists && this.props.menuLists.length > 0 && this.state.loadOnce){
            let subMenu = [];
            let dynamicMenu = [];
            dynamicMenu = this.props.menuLists.map((menu) => {
                if(menu.menuRights.length > 0){
                    subMenu = (menu.mainmenu !=='Reporting Systems') ? menu.menuRights.map((sub) => {
                        if(sub.viewAccess === true){
                            return {
                                label: Lang=="En"?sub.subMenuName:sub.subMenuNameAr, to : '/'+sub.url
                            }
                        }else{
                            return{};
                        }
                    }) : menu.menuRights.map((sub) => {
                        if(sub.viewAccess === true){
                            if(sub.subMenuId == "72c511d7-cbe2-42dd-ac09-25c8639d9b49"){
                                return {
                                    label: Lang=="En"?sub.subMenuName:sub.subMenuNameAr, to : '/'+sub.url
                                }
                            }else return {
                                label: Lang=="En"?sub.subMenuName:sub.subMenuNameAr, to : '/report/view/'+sub.subMenuId
                            }
                        }else{
                            return{};
                        }
                    })

                }
                subMenu = subMenu.filter(value => Object.keys(value).length !== 0);
                subMenu = subMenu.filter( (ele, ind) => ind === subMenu.findIndex( elem => elem.label === ele.label))
                let returnMenu = { label: Lang=="En"?menu.mainmenu :menu.mainmenuAr , icon : menu.icon, to : '/dashboard'};
                // added by abu 20june
                const userrole = localStorage.getItem('UserRole');
                if (userrole == "80" || userrole == "85" || userrole == "90"){
                returnMenu = { label: Lang=="En"?menu.mainmenu :menu.mainmenuAr , icon : menu.icon, to : '/dashboardservice'};
                }
                //end add
                if(menu.mainmenu !=='DashBoard'){
                     returnMenu = { label: Lang=="En"?menu.mainmenu :menu.mainmenuAr  , icon : menu.icon, items:subMenu }
                }
                return returnMenu;
            })
            this.menu= [...dynamicMenu];
            this.setState({loadOnce:false});
        }
    }
    
   

    // Vendor deep link (/add-supplierquotation/:type/:id/:vid/:rfqid) — vendors
    // have no HRMS account, so SupplierQuotation.js trades the :vid in the URL
    // for a real session in its own componentDidMount (see onVendorAuth there).
    // Mirrors POSApp's isQrOrderPath()/QrGuestGate split for the same reason:
    // running authCheckState here on a brand-new device (no token yet) would
    // dispatch logout() and clobber the token that vendor auth is about to set.
    isVendorQuotationPath = () => {
        const { pathname } = this.props.location;
        return matchPath(pathname, {
            path: '/add-supplierquotation/:type/:id/:vid/:rfqid',
            exact: true
        }) !== null;
    };

    componentDidMount() {
        if (!this.isVendorQuotationPath()) {
            this.props.onTryAuthSignUp();
        }
        setTimeout(() => {
            if(this.props.userID !== null && this.props.userID !== undefined){
                //this.props.onMenuAccess(this.props.userID,'GetAuthorization');
                //this.props.onMenuAccess(0,'GetInitialAccess');
            }
        }, 5000);
        this.setupBeforeUnloadListener();
    }


    imageMenu = (event) => {
        this.menu1.toggle(event);
    }
    

    closePhoto = () => {
        this.setState({viewPhoto:false})
    }
    

    closeUploadPhoto = () => {
        this.setState({uploadPhoto:false})
    }

    closeTakePhoto = () => {
        this.setState({takePhoto:false})
    }


    render() {

        // Vendor deep link — rendered standalone, never gated by the staff
        // isAuthenticated redirect below (see isVendorQuotationPath's comment
        // on componentDidMount for why). No staff topbar/sidebar/menu around
        // a vendor's own device; SupplierQuotation.js handles its own loading
        // UI while onVendorAuth trades the :vid in the URL for a session.
        if (this.isVendorQuotationPath()) {
            return (
                <>
                    { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                    <Route path="/add-supplierquotation/:type/:id/:vid/:rfqid" exact component={AddSupplierQuotation} />
                </>
            );
        }

        //  let logo = require('./assets/images/logo.jpg');
       // let logo = require('./assets/images/APCO0.png');
        let logo = require('./assets/images/Chenthoor_landscape_Logo-removebg-preview.png');
        
        const userrole = localStorage.getItem('UserRole');
        // if (userrole == "80" || userrole == "85" || userrole == "90"){
        //     logo = require('./assets/images/logoe.png');
        // }
        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark'
        });


        // Nothing is rendered at "/" — it always sends you on, and never falls
        // through to the branch below, which would render the staff shell with no
        // route to match and so a blank page.
        //
        // Signed in, that is the user's own default page. Otherwise it is the public
        // home page, the customer special order screen. One rule covers the '9999'
        // guest account the customer pages sign every visitor in as, because its
        // own default page is that same screen — see GET_SESSION_HOME_PATH.
        if (this.props.location.pathname === '/') {
            return <Redirect to={GET_SESSION_HOME_PATH() || GUEST_HOME_PATH}/>;
        }

        // The guest account gets the special order page and nothing else here; the
        // login form stays reachable so an employee can sign in over it.
        if (IS_GUEST_SESSION() && this.props.location.pathname !== LOGIN_PATH) {
            return <Redirect to={GUEST_HOME_PATH}/>;
        }

        // Everything else here is staff-facing, so signed out it goes to the login
        // form — never to "/", which would land an employee on the ordering screen
        // with no way to sign in.
        //
        // "Signed out" has to mean more than !isAuthenticated during a login. The
        // auth action stores the token in localStorage first, then dispatches the
        // authentication response (which is what moves the login page to the user's
        // default page) two dispatches BEFORE authSuccess puts the token in redux.
        // So there is a window where the navigation has happened but redux still
        // reads as signed out — and this redirect dragged it straight back to the
        // login page, leaving the session to finish arriving with the URL still on
        // /login: sidebar loads, address bar never moves. A stored token closes
        // that window; authCheckState clears it if it turns out to be stale, and
        // logout() clears it too, so a genuinely signed-out visitor still bounces.
        let redirectUrl = null;

        if(!this.props.isAuthenticated && !localStorage.getItem('token')
            && this.props.location.pathname !== LOGIN_PATH){
            redirectUrl = <Redirect to={LOGIN_PATH}/>
        }

        return (
            <>
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Menu model={this.state.items} ref={(el)=>this.menu1=el} popup={true} />
                {redirectUrl}
            { 
                !this.props.isAuthenticated ? (
                <>
                    <Route path={LOGIN_PATH} exact component={Login} />
                </>
                ) :
                (
                    <div className={wrapperClass} onClick={this.onWrapperClick}>
                        
                        <AppTopbar onToggleMenu={this.onToggleMenu} menuActive={this.state.staticMenuInactive} userDetail={this.props.userDetail}/>
                        
                      <div
                            ref={(el) => this.sidebar = el}
                            className={sidebarClassName}
                            onClick={this.onSidebarClick}>
                            <div className="layout-logo">
                                <img alt="Logo" src={logo} style={{maxWidth: '280px', maxHeight: '60px', width: 'auto', height: 'auto'}}/>
                            </div> 
                            <AppProfile imageMenu={this.imageMenu} viewPhoto={this.state.viewPhoto} closePhoto={this.closePhoto} uploadPhoto={this.state.uploadPhoto} closeUploadPhoto={this.closeUploadPhoto} takePhoto={this.state.takePhoto} closeTakePhoto={this.closeTakePhoto} userDetail={this.props.userDetail} isAuthenticated={this.props.isAuthenticated}/> 
                            <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick}/>
                        </div>

                        <div className="layout-main">
                            <Switch>

                               

                                <Route path="/invanalytics" exact component={InventoryDashboard}/>


                                <Route path="/dashboard" exact component={Dashboard}/>
                                {/* <Route path="/headcount" exact component={Headcount}/> */}
                                {/* <Route path="/empcalendar" exact component={Empcalendar}/> */}

                                <Route path="/HCHeadCount" exact component={Headcount}/>
                                <Route path="/HCCalendar" exact component={Empcalendar}/>

        


                                <Route path="/process-list" exact component={ProcessList}/>
                                <Route path="/process-form" exact component={ProcessForm}/>
                                <Route path="/process-form/:type/:processID" exact component={ProcessForm}/>
                                <Route path="/users" exact component={UserManagement}/>
                                <Route path="/user/:type/:id" exact component={AddUser}/>
                                <Route path="/employee-group" exact component={EmployeeGroup}/>
                                <Route path="/employee-group/:type/:id" exact component={AddEmployeeGroup}/>
                                <Route path="/employee-master" exact component={EmployeeMaster}/>
                                <Route path="/employee-master/:type/:id" exact component={AddEmployeeMaster}/>
                                <Route path="/WCAStatus" exact component={WPStatusMaster}/>
                                <Route path="/WCAStatus/:type/:id" exact component={AddWPStatusMaster}/>

                                <Route path="/Certificate-Master" exact component={CertificateMaster}/>
                                <Route path="/Certificate-Master/:type/:id" exact component={AddCertificateMaster}/>
                                
                               

                                <Route path="/time-off-type/:type/:id" exact component={TimeOffType}/>
                                <Route path="/time-off-type-list" exact component={TimeOffTypeList}/>
                                {/* <Route path="/expense-claim" exact component={ExpensesClaim}/> */}

                                <Route path="/time-off-type-policy" exact component={TimeOffTypePolicyList}/>
                                <Route path="/time-off-type-policy/:type/:id" exact component={TimeOffTypePolicy}/>
                            

                                <Route path="/daily-shift" exact component={DailyShift}/>
                                <Route path="/daily-shift/:type/:id" exact component={AddDailyShift}/>


                                <Route path="/periodic-schedule" exact component={PeriodicWorkSchedule}/>
                                <Route path="/periodic-schedule/:type/:id" exact component={AddPeriodicSchedule}/>

                                <Route path="/punch-editing" exact component={PunchEditing}/>
                                <Route path="/punch/:type/:id" exact component={AddPunchEditing}/>
                                
                                <Route path="/approval-type" exact component={ApprovalType}/>
                                <Route path="/approval-path" exact component={ApprovalPath}/>

                                
                                

                                <Route path="/keyword-master" exact component={KeywordMaster}/>
                                <Route path="/company-master" exact component={CompanyMaster}/>
                                <Route path="/holiday-master" exact component={HolidayMaster}/>
                                <Route path="/position-master" exact component={PositionMaster}/>

                                <Route path="/position/:type/:id" exact component={AddPosition}/>

                                <Route path="/organization-unit" exact component={OrganizationUnit}/>
                                <Route path="/organization-unit/:type/:id" exact component={AddOrganizationUnit}/>
                                

                                

                                <Route path="/news-settings" exact component={News}/>
                                <Route path="/company-policy" exact component={CompanyPolicy}/>
                                
                                <Route path="/email-template-master" exact component={EmailTemplateMasterlist}/>
                                <Route path="/email-template-master/:type/:id" exact component={EmailTemplateMaster}/>
                                <Route path="/help-library" exact component={HelpLibrary}/>
                                <Route path="/organization-chart" exact component={OrganizationCharts}/>
                                <Route path="/position-chart" exact component={PositionChart}/>
                                <Route path="/department-chart" exact component={DepartmentCharts}/>
                                

                                <Route path="/role-master" exact component={Role}/>

                                <Route path="/reports-setting" exact component={ReportsList}/>
                                <Route path="/report/:type/:id" exact component={ReportsSetting}/>

                                
                               
                                <Route path="/error-logs" exact component={ErrorLogs} />
                    

                                <Route path="/search" exact component={Search}/>
                                <Route path="/policy/:name" exact component={Policy}/>
                                <Route path="/settings" exact component={Settings}/>
                                <Route path="/log-out" exact component={Logout}/>
                                <Route path="/forms" component={FormsDemo}/>
                                <Route path="/sample" component={SampleDemo}/>
                                <Route path="/data" component={DataDemo}/>
                                <Route path="/panels" component={PanelsDemo}/>
                                <Route path="/overlays" component={OverlaysDemo}/>
                                <Route path="/menus" component={MenusDemo}/>
                                <Route path="/messages" component={MessagesDemo}/>
                                <Route path="/charts" component={ChartsDemo}/>
                                <Route path="/misc" component={MiscDemo}/>
                                <Route path="/empty" component={EmptyPage}/>
                                <Route path="/" exact component={Login} />


                                <Route path="/KPI-Master" exact component={KpiList}/>
                                <Route path="/Add-KPI" exact component={AddKpi}/>
                                <Route path="/Add-KPI/:type/:id" exact component={AddKpi}/>

                                <Route path="/SLA-Master" exact component={SlaList}/>
                                <Route path="/SLA-Master/:type/:id" exact component={AddSla}/>                                


                                <Route path="/Project" exact component={ProjectList}/>
                                <Route path="/Project/:type/:id" exact component={AddProject}/>

                                
                                
                                <Route path="/Vendor" exact component={VendorList}/>
                                <Route path="/Vendor/:type/:id" exact component={AddVendor}/>

                               {/* CostCenterMaster */}

                                <Route path="/CostCenter" exact component={CostCenter} />
                                <Route path="/CostCenter/:type/:id" exact component={AddCostCenter}/>


                                <Route path="/materialpass-vehicle" exact component={MaterialPassVehicleList}/>
                                <Route path="/Add-MaterialPass-Vehicle" exact component={AddMaterialPassVehicle}/>
                                <Route path="/Add-MaterialPass-Vehicle/:type/:id" exact component={AddMaterialPassVehicle}/>


                                <Route path="/gatepass-visitor" exact component={GatePassVisitorList}/>
                                <Route path="/Add-Visitor-Gatepass" exact component={AddGatePassVisitor}/>
                                <Route path="/Add-Visitor-Gatepass/:type/:id" exact component={AddGatePassVisitor}/>


                                {/* <Route path="/business-trip" exact component={BusinessTrip}/>
                                <Route path="/add-business-trip" exact component={AddBusinessTrip}/>
                                <Route path="/add-business-trip/:type/:id" exact component={AddBusinessTrip}/> */}
                        
                                {/* Event Management */}
                                <Route path="/event-management" exact component={EventManagement}/>
                                <Route path="/add-event-management" exact component={AddEventManagement}/>
                                <Route path="/add-event-management/:type/:id" exact component={AddEventManagement}/>
                                
                                {/* Numbering Scheme */}
                                <Route path="/numbering-scheme/:type/:id" exact component={NumberingScheme}/>
                                <Route path="/numbering-scheme-list" exact component={NumberingSchemeList}/>

                                {/* people Master  */}
                                <Route path="/People" exact component={Peoplelist}/>
                                <Route path="/People/:type/:id" exact component={AddPeople}/>

                                <Route path="/overtime-pre-approval-form" exact component={OverTimePreApproval} />
                                <Route path="/overtime-pre-approval-form/:type/:id" exact component={OverTimePreApproval} />
                                <Route path="/overtime-pre-approval" exact component={OverTimePreApprovalList} />


                                <Route path="/Add-Moblization" exact component={Moblization}/>
                                <Route path="/Add-Moblization/:type/:id" exact component={Moblization}/>
                                <Route path="/Moblization" exact component={MoblizationList} />       
                                        

                                                               
                                <Route path="/Add-DeMoblization" exact component={DeMoblization}/>
                                <Route path="/Add-DeMoblization/:type/:id" exact component={DeMoblization}/>
                                <Route path="/DeMoblization" exact component={DeMoblizationList} />

                                {/* <Route path="/Add-DeMoblization" exact component={AddDeMoblization}/>
                                <Route path="/Add-DeMoblization/:type/:id" exact component={AddDeMoblization}/>
                                <Route path="/DeMoblization" exact component={DeMoblizationList} /> */}

                                <Route path="/break-permission-process" exact component={BreakPermissionProcess}/>
                                <Route path="/break-permission-process-request" exact component={BreakPermissionProcessRequest}/>
                                <Route path="/break-permission-process-request/:type/:id" exact component={BreakPermissionProcessRequest}/>

                                <Route path="/timesheet" exact component={TimeSheet}/>
                                <Route path="/add-timesheet-process" exact component={AddTimesheetProcess}/>
                                <Route path="/add-timesheet-process/:type/:id" exact component={AddTimesheetProcess}/>
                                <Route path="/view-timesheet" exact component={ViewTimeSheet}/>
                                    
                                    {/* //added on feb 2 */}
                                <Route path="/work-schedule" component={workSchedule} />
                                 <Route path="/work-schedule-single" component={workScheduleSingle}/>

                                 <Route path="/shift-approval-single" exact component={ShiftApprovalSingle}/>
                                <Route path="/shift-approval-single/:type/:id" exact component={ShiftApprovalSingle} />

                                <Route path="/shift-approval" exact component={ShiftApproval}/>
                                <Route path="/shift-approval/:type/:id" exact component={ShiftApproval} />

                                <Route path="/overtime-pre-approval-form" exact component={OverTimePreApproval} />
                                <Route path="/overtime-pre-approval-form/:type/:id" exact component={OverTimePreApproval} />
                                <Route path="/overtime-pre-approval" exact component={OverTimePreApprovalList} />

                                <Route path="/Add-TimeBooking" exact component={AddTimeBooking}/>
                                <Route path="/Add-TimeBooking/:type/:id" exact component={AddTimeBooking}/>
                                <Route path="/TimeBooking" exact component={TimeBookingList} />

                                <Route path="/HR-Analytics" exact component={AnalyticsHr}/>
                                <Route path="/OM-Analytics" exact component={AnalayticsOperation}/>

                                <Route path="/payroll-report" exact component={PayrollReport}/>
                                <Route path="/add-payroll-report" exact component={AddPayrollReport}/>
                                <Route path="/add-payroll-report/:type/:id" exact component={AddPayrollReport}/>

                                <Route path="/EmployeeLoan" exact component={EmployeeLoan}/>
                                <Route path="/add-EmployeeLoan" exact component={AddEmployeeLoan}/>
                                <Route path="/add-EmployeeLoan/:type/:id" exact component={AddEmployeeLoan}/>

                                <Route path="/DailyActivity" exact component={DailyActivity}/>
                                <Route path="/add-daily-activity" exact component={AddDailyActivity}/>
                                <Route path="/add-daily-activity/:type/:id" exact component={AddDailyActivity}/>

                                <Route path="/purchaseorder" exact component={PurchaseOrder}/>
                                <Route path="/add-purchase-order" exact component={AddPurchaseOrder}/>
                                <Route path="/add-purchase-order/:type/:id" exact component={AddPurchaseOrder}/>

                                <Route path="/wastage" exact component={Wastage}/>
                                <Route path="/add-wastage" exact component={AddWastage}/>
                                <Route path="/add-wastage/:type/:id" exact component={AddWastage}/>

                                <Route path="/goodsreceiptnote" exact component={GoodsReceiptNote}/>
                                <Route path="/add-goodsreceiptnote" exact component={AddGoodsReceiptNote}/>
                                <Route path="/add-goodsreceiptnote/:type/:id" exact component={AddGoodsReceiptNote}/>

                                <Route path="/Recipe" exact component={Recipe}/>
                                <Route path="/Recipe/:type/:id" exact component={AddRecipe}/>
                            
                                <Route path="/Assembly" exact component={Assembly}/>
                                <Route path="/Assembly/:type/:id" exact component={AddAssembly}/>

                                <Route path="/Asset" exact component={AssetMaster}/>
                                <Route path="/Asset/:type/:id" exact component={AddAssetMaster}/>

                                <Route path="/master" exact component={MasterSelection} />

                                {/* <Route path="/select-module" component={ModuleSelectionPage} /> */}
                                <Route path="/inventory-settings" exact component={InventorySettings} />
                                <Route path="/Barcode-generation" exact component={BarcodeGeneration} />
                                <Route path="/current-stock-report" exact component={CurrentstockReport} />
                                <Route path="/consumption-report" exact component={ConsumptionReport} />
                                <Route path="/food-costing-report" exact component={FoodCostingReport} />
                                <Route path="/expiry-report" exact component={ExpiryReport} />
                                <Route path="/stock-summary-report" exact component={StockSummaryReport} />

                                <Route path="/formatted-report" exact component={FormattedReportSelection} />
                                <Route path="/formatted-daily-sales-report" exact component={RestaurantDailySalesReport} />
                                <Route path="/formatted-itemwise-sales-summary-report" exact component={ItemwiseSalesSummaryReport} />
                                <Route path="/formatted-cash-handover-from-sales-report" exact component={CashHandoverFromSalesReport} />
                                <Route path="/formatted-cash-summary-report" exact component={CashSummaryReport} />
                                <Route path="/formatted-employee-salary-report" exact component={EmployeeSalaryReport} />
                                <Route path="/formatted-sales-report" exact component={SalesReport} />

                                <Route path="/guests-master" exact component={GuestsAndEmployeeUploads} />
                                <Route path="/orderinfo-master" exact component={OrderInfo} />
                                <Route path="/ratecard-master" exact component={RateCard} />
                                <Route path="/tax-master" exact component={TaxMaster} />
                                <Route path="/addtax-master/:type/:id" exact component={AddTaxMaster} />

                                <Route path="/menuitemmealperiod" exact component={MenuItemMealPeriod} />
                                <Route path="/menuitemmealperiod/:type/:id" exact component={AddMenuItemMealPeriod} />
                                <Route path="/mealperiodlist" exact component={MealPeriodList} />
                                <Route path="/mealperiodlist/:type/:id" exact component={AddMealPeriodList} />
                                <Route path="/kotinformation" exact component={KOTInformationMaster} />
                                <Route path="/kotinformation/:type/:id" exact component={AddKOTInformationMaster} />
                                <Route path="/occasion" exact component={OccasionMaster} />
                                <Route path="/occasion/:type/:id" exact component={AddOccasionMaster} />

                                <Route path="/sales-report" exact component={DailySalesReport} />
                                <Route path="/AccountsMaster" exact component={AccountsMaster} />
                                <Route path="/AccountsMaster/:type/:id" exact component={AddAccountsMaster} />

                                <Route path="/financialstatementversion" exact component={FinancialStatementVersion} />
                                <Route path="/financialstatementversion/:type/:id" exact component={AddFinancialStatementVersion} />

                                <Route path="/ingredient" exact component={Ingredient} />
                                <Route path="/ingredient/:type/:id" exact component={AddIngredient} />

                                <Route path="/menuitem" exact component={Menuitem} />
                                <Route path="/menuitem/:type/:id" exact component={AddMenuitem} />

                                <Route path="/menuitemcategory" exact component={Menuitemcat} />
                                <Route path="/menuitemcategory/:type/:id" exact component={AddMenuitemcat} />

                                <Route path="/purchasereturn" exact component={PurchaseReturn} />
                                <Route path="/add-purchase-return" exact component={AddPurchaseReturn} />
                                <Route path="/add-purchase-return/:type/:id" exact component={AddPurchaseReturn} />
                                
                                <Route path= "leave-requestlis" exact component={LeaveRequestList} />
                                <Route path= "leave-request/:type/:id" exact component={LeaveRequest} />

                                <Route path="/modifier" exact component={Modifier} />
                                <Route path="/modifier/:type/:id" exact component={AddModifier} />

                                <Route path="/modifiergroup" exact component={ModifierGroup} />
                                <Route path="/modifiergroup/:type/:id" exact component={AddModifierGroup} />

                                <Route path="/outlet" exact component={OutletMaster} />
                                <Route path="/outlet/:type/:id" exact component={AddOutletMaster} />

                                <Route path="/store" exact component={StoreMaster} />
                                <Route path="/store/:type/:id" exact component={AddStoreMaster} />

                                <Route path="/generateproduction" exact component={GenerateProductionPlanning} />
                                <Route path="/MRP" exact component={MRP} />

                                <Route path="/kitchen" exact component={KitchenMaster} />
                                <Route path="/kitchen/:type/:id" exact component={AddKitchenMaster} />

                                {/* Property Related Master  */}
                                <Route path="/Tenant" exact component={TenantsAndOwners} />
                                <Route path="/Tenant/:type/:id" exact component={AddTenantsAndOwners} />

                                <Route path="/Service" exact component={Service} />
                                <Route path="/Service/:type/:id" exact component={AddService} />

                                <Route path="/TenantZone" exact component={TenantZone} />
                                <Route path="/TenantZone/:type/:id" exact component={AddTenantZone} />

                                <Route path="/PropertyGroup" exact component={PropertyGroup} />
                                <Route path="/PropertyGroup/:type/:id" exact component={AddPropertyGroup} />

                                <Route path="/Property" exact component={Property} />
                                <Route path="/Property/:type/:id" exact component={AddProperty} />

                                <Route path="/tenants-owner-movie-master" exact component={MovieIn} />
                                <Route path="/tenants-owner-movie-master/:type/:id" exact component={AddMovieIn} />

                                 <Route path="/table" exact component={TableMaster} />
                                 <Route path="/table/:type/:id" exact component={AddTableMaster} />
                                       
                                 <Route path="/ordertype" exact component={OrderType} />
                                 <Route path="/ordertype/:type/:id" exact component={AddOrderType} />

                                 <Route path="/requestforquotation" exact component={RequestforQuotation} />
                                 <Route path="/add-requestforquotation/:type/:id" exact component={AddRequestforQuotation} />
                                
                                <Route path="/supplierquotation" exact component={SupplierQuotation} />
                                <Route path="/add-supplierquotation/:type/:id/" exact component={AddSupplierQuotation} />
                                <Route path="/add-supplierquotation/:type/:id/:vid/:rfqid" exact component={AddSupplierQuotation} />

                                <Route path="/VendorRegistration" exact component={VendorRegistrationList} />
                                <Route path="/add-VendorRegistration" exact component={VendorRegistration} />
                                <Route path="/add-VendorRegistration/:type/:id" exact component={VendorRegistration} />

                                <Route path="/openingstock" exact component={OpeningStockList} />
                                <Route path="/add-openingstock/:type/:id" exact component={OpeningStock} />

                                <Route path="/physicalstock" exact component={PhysicalStockList} />
                                <Route path="/add-physicalstock/:type/:id" exact component={PhysicalStock} />

                                <Route path="/productionplanning" exact component={ProductionPlanningList} />
                                <Route path="/add-productionplanning/:type/:id" exact component={AddProductionPlanning} />

                                <Route path="/purchaserequisition" exact component={PurchaseRequisitionList} />
                                <Route path="/add-purchaserequisition/:type/:id" exact component={PurchaseRequisition} />

                                <Route path="/materialrequirementplanning" exact component={MaterialRequirementPlanningList} />
                                <Route path="/add-materialrequirementplanning/:type/:id" exact component={AddMaterialRequirementPlanning} />

                                <Route path="/ImprestSystem" exact component={ImprestSystem} />
                                <Route path="/add-ImprestSystem/:type/:id" exact component={AddImprestSystem} />

                                <Route path="/TransactionType" exact component={TransactionType} />
                                <Route path="/TransactionType/:type/:id" exact component={AddTransactionType} />

                                 <Route path="/journalvoucher" exact component={JournalVoucherList} />
                                <Route path="/add-journalvoucher/:type/:id" exact component={JournalVoucher} />
                                <Route path="/salesorder" exact component={SalesOrderList} />
                                <Route path="/add-salesorder/:type/:id" exact component={SalesOrder} />
                                
                                <Route path="/marketingcampaign" exact component={MarketingCampaignList} />
                                <Route path="/add-marketingcampaign/:type/:id" exact component={MarketingCampaign} />
                                <Route path="/Soldout" exact component={Soldout} />
                                <Route path="/RecInvoice" exact component={InvoiceList} />
                                <Route path="/Add-RecInvoice" exact component={AddRecInvoice} />
                                <Route path="/Add-RecInvoice/:type/:id" exact component={AddRecInvoice} />
                                

                                {/* ZATCA */}
                                <Route path="/zatca-company" exact component={ZatcaCompany} />
                                <Route path="/zatca-units" exact component={ZatcaUnits} />
                                <Route path="/zatca-units/:type/:id" exact component={AddZatcaUnit} />
                                <Route path="/zatca-onboarding/:id" exact component={ZatcaOnboarding} />
                                <Route path="/zatca-monitor" exact component={ZatcaMonitor} />


                            </Switch>


                            
                            {/* <Redirect to="/"/> */}
                        </div>

                        <AppFooter/>
                        <GlobalStyle />
                    
                        <div className="layout-mask"></div>
                    </div>
                )
            }
            </>
        );
    }
}

const mapStateToProps = state => {
    return{
        isAuthenticated : state.auth.token !== null,
        userID : (state.auth.userDetail !== null) ? state.auth.userDetail.userId : '',
        userDetail: state.auth.userDetail,
        menuLists : state.auth.menuLists,
        loading: state.auth.loading,
        error : state.auth.error
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        onTryAuthSignUp : () => dispatch(actions.authCheckState()),
        onMenuAccess    : (empID,type) => dispatch(actions.getMenuAccess(empID,type))
    }
}
  
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(App));